import {BrowserRouter as Router ,Routes,Route} from 'react-router-dom';
import './App.css';
import Home from './pages';
import Message from './pages';


function App() {
  return (

    <Router>

      <Routes>
          <Route path="/" component={Home} exact/>
          <Route path="/message" component={Message} exact/>
      </Routes>

<Home/>
    </Router>
  );
}

export default App;
